(function($) {

    let $stickyFooter = $('.sticky-footer');
    let $siteFooter = $('#site-footer');

    let footerheight = $stickyFooter.outerHeight();
    let windowheight = $(window).height();
    let footerRevealed = false;

    if (footerheight < windowheight) {
        $stickyFooter.addClass('pinnable');
        adjustFooter();
    }

    $(document).ready(function() {
        'use strict';

        if (footerheight < windowheight) {
            $stickyFooter.addClass('pinnable');
            adjustFooter();
        }

    });

    if ($('.hero.startpage .primary-button').length > 0) {
        $(document.body)
            .on('click', '.hero.startpage .primary-button', function(e) {
                'use strict';
                e.preventDefault();

                console.log($(document).height());

                $('html, body').animate({scrollTop: $siteFooter.offset().top});

            });
    }

    $(window).scroll(function(event) {
        // console.log( $(document).height() );
        if (footerheight < windowheight) {
            adjustFooter();
        }
    });

    $(window).resize(function() {
        footerheight = $stickyFooter.outerHeight();
        windowheight = $(window).height();

        if (footerheight < windowheight) {
            $stickyFooter.addClass('pinnable');
            adjustFooter();
        } else {
            $stickyFooter.removeClass('pinnable visible');
            $siteFooter.css('margin-bottom', '0');
            $('body').removeClass('sticky-footer-active');
            footerRevealed = false;
        }
    });

    function adjustFooter() {
        // Reveal and hide use different thresholds (hysteresis) rather
        // than a single boundary: with one shared threshold, the tiny
        // scroll jitter that happens right at that line flickers the
        // reveal on and off. The gap between the two thresholds is a dead
        // zone where whatever state is already showing just stays put.
        if (is_scrolled_to_bottom()) {
            if (!footerRevealed) {
                $stickyFooter.addClass('visible');
                $siteFooter.css('margin-bottom', footerheight - 1);
                $('body').addClass('sticky-footer-active');
                footerRevealed = true;
            }
        } else if (is_scrolled_away_from_bottom()) {
            if (footerRevealed) {
                $stickyFooter.removeClass('visible');
                $siteFooter.css('margin-bottom', '0');
                $('body').removeClass('sticky-footer-active');
                footerRevealed = false;
            }
        }
    }

    function is_scrolled_to_bottom() {
        let windowheight = $(window).height();
        let scrollTop = $(window).scrollTop();
        let docHeight = $(document).height();

        // Trigger once only half a footer-height of scroll room remains,
        // instead of waiting for the exact last pixel (which left the
        // footer's reserved space blank/invisible for too long while
        // scrolling) or firing the moment it's merely reachable (too early).
        return (scrollTop + windowheight) >= (docHeight - (footerheight / 2));
    }

    function is_scrolled_away_from_bottom() {
        let windowheight = $(window).height();
        let scrollTop = $(window).scrollTop();
        let docHeight = $(document).height();

        // Only hide again once scrolled a full footer-height further up
        // than the reveal threshold — otherwise the footer stays pinned
        // fixed over unrelated content for the rest of the page visit
        // (visible as a dark overlay) any time it revealed early, e.g. on
        // pages not much taller than the viewport.
        return (scrollTop + windowheight) < (docHeight - footerheight * 1.5);
    }

})(jQuery);
